module.exports = __webpack_public_path__ + "img/img-4.d9224039.svg";